import CVBuilder from './components/CVBuilder';
export default function App() { return <CVBuilder />; }
